export default __webpack_public_path__ + "static/media/roam.8737ac35.png";